<template>
  <div>
      <div
        v-if="showModal"
        :class="modalClasses"
      >
        <div :class="modalBgColor" class="justify-center p-8 w-full flex flex-col">
          <p class="text-white text-center" v-html="modalData.text"></p>
          <div class="container mx-auto py-4 relative">
            <div :class="modalButtonColor" class="absolute pin-l rounded-full ml-5 px-6 py-2">
              <p
              :class="modalButtonTextColor"
                @click="onConfirm"
              > {{$t('all.yes')}}</p>
            </div>
            <div :class="modalButtonColor" class="absolute pin-r rounded-full mr-5 px-6 py-2">
              <p
               :class="modalButtonTextColor"
                @click="onCancel"
              > {{$t('all.no')}}</p>
            </div>
          </div>
          <span
            @click="onCancel"
            class="absolute pin-t pin-r pt-16 px-4"
          >
            <i class="fa fa-times text-white fa-xs"></i>
          </span>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    showModal: { required: true },
    modalData: { required: true },
    modalClasses: { type: String, default: 'z-50 w-full flex h-screen py-18' },
    modalBgColor: { type: String, default: 'bg-yellow' },
    modalButtonColor: { type: String, default: 'bg-pink-dark' },
    modalButtonTextColor: { type: String, default: 'text-white' }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss">
</style>
